function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04,0,0,0.04,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.738,373.011C319.09,378.039 261.503,386.718 250,386.718C145.955,386.718 54.691,330.475 5.77,246.419C-1.923,233.202 -1.923,216.799 5.77,203.582C27.71,165.886 58.161,133.8 94.448,109.863C94.448,109.863 148.584,78.447 171.882,74.218C196.712,67.099 222.924,63.282 250,63.282C354.045,63.282 445.31,119.526 494.23,203.582C501.922,216.799 501.922,233.201 494.23,246.418C465.495,295.789 422.157,335.529 370.229,359.943L369.618,360.23C369.618,360.23 354.475,366.669 334.745,373.009L334.738,373.011ZM308.663,336.854L345.283,325.03L345.471,324.941C346.264,324.568 347.033,324.236 347.777,323.942C394.289,303.347 433.011,268.51 458.333,225C420.003,159.141 350.975,113.142 270.693,106.342C262.19,115.206 256.945,127.292 256.945,140.625C256.945,167.808 278.708,189.844 305.555,189.844C332.403,189.844 354.168,167.808 354.168,140.625L354.165,140.588C380.755,190.929 368.698,255.075 322.11,291.513C322.11,291.513 291.807,319.488 237.145,315.647L236.509,315.649C235.314,315.636 234.087,315.464 232.83,315.143C199.599,310.255 171.53,291.595 153.494,265.691C134.76,238.784 126.85,204.06 135.219,168.835L135.242,168.736C135.629,167.058 141.092,144.333 156.754,126.218L154.395,121.895L118.355,144.441L117.618,144.923C86.482,165.365 60.404,192.807 41.667,225C83.254,296.455 160.976,344.53 250,344.53C252.208,344.528 282.27,342.847 308.663,336.854Z",
    style: {
      fill: "rgb(106,106,106)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpen);
export default __webpack_public_path__ + "static/media/icon-eye-open.09adb1d6674a5fa7bdd0a8248e0c85de.svg";
export { ForwardRef as ReactComponent };